module.exports = __webpack_public_path__ + "static/media/galerija_2022_0003.40dee0c5.jpg";